"use strict";
/**
 * @class MetaItems a.k.a. Key-Value pairs
 * @description meta item components
 * @spec https://confluence.oci.oraclecorp.com/display/UX/Key-Value+Pairs
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../index");
var unicode_1 = require("../utils/unicode");
var Messages = require("../codegen/Messages");
// @todo - next breaking change, make these a better enum, they were exported public with text values
var MetaItemStatus;
(function (MetaItemStatus) {
    /**
     * Display meta item value in normal state.
     */
    MetaItemStatus["Normal"] = "Normal";
    /**
     * Display loading state.
     */
    MetaItemStatus["Loading"] = "Loading...";
    /**
     * Display no value state.
     */
    MetaItemStatus["NotAvailable"] = "No Value";
})(MetaItemStatus = exports.MetaItemStatus || (exports.MetaItemStatus = {}));
/**
 * Key-value pairs display metadata about an item.
 *
 * @oui-component LabelMetaItem
 */
exports.LabelMetaItem = function (props) {
    var isDisabled = props.status && props.status !== MetaItemStatus.Normal;
    var hintId = index_1.uniqueGUID();
    var statusText = function (status) {
        switch (status) {
            case MetaItemStatus.Loading:
                return Messages.Common.loading();
            case MetaItemStatus.NotAvailable:
                return Messages.MetaItems.notAvailable();
            default:
                return undefined;
        }
    };
    return (React.createElement("div", { className: "oui-metadata-items-wrapper", "data-test-id": props.testId },
        React.createElement("strong", { id: hintId },
            props.label,
            ":"),
        unicode_1.nonBreakingSpace,
        isDisabled ? (React.createElement("em", { className: "oui-text-muted", "aria-labelledby": hintId }, statusText(props.status))) : (React.createElement("span", { className: "oui-metadata-items__content", "aria-labelledby": hintId }, props.children))));
};
//# sourceMappingURL=MetaItems.js.map